import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get the current list of supported flow nodes
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetFlowNodes = packet => {
  return {
    type: 'REQUEST_GET_FLOW_NODES',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetFlowNodesSuccess = data => ({
  type: 'RECEIVE_GET_FLOW_NODES_SUCCESS',
  data
})

export const receiveGetFlowNodesFail = data => ({
  type: 'RECEIVE_GET_FLOW_NODES_FAIL',
  data
})

export const tryToGetFlowNodes = packet => (dispatch, getState) => {

  dispatch(requestGetFlowNodes(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = Cookies.get(process.env.REACT_APP_COOKIE_FEATURE_SWITCH)
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/intel/flow-nodes', {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetFlowNodesSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetFlowNodesFail({errors:e, lastSubmit: packet}));
    })
}
